export default "__VITE_ASSET__97501f47__"